module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#textsms",
      toString: function () {
        return this.url;
      }
    }